module.exports = __webpack_public_path__ + "static/media/CGU.7c861db9.pdf";